import type { ReviewSample } from '../../api/rendersApi';

// Same window/credit limits as render review, on exact story-only audio.
export function narrationReviewSamples(duration: number): ReviewSample[] {
  if (!Number.isFinite(duration) || duration <= 0) return [];
  const window = Math.min(25, duration / 3);
  return [
    { sample_id: 'opening' as const, label: 'Beginning', start: 0 },
    { sample_id: 'middle' as const, label: 'Middle', start: (duration - window) / 2 },
    { sample_id: 'closing' as const, label: 'End', start: duration - window },
  ].map(({ sample_id, label, start }) => ({
    sample_id, label, start_seconds: start, end_seconds: start + window,
    required_seconds: Math.min(12, window * 0.75), kind: 'story' as const,
  }));
}

export function heardNarrationSamples(samples: ReviewSample[], played: TimeRanges): string[] {
  // Browser playback ranges prevent seeking or replaying the same seconds
  // from creating credit for unheard audio.
  return samples.filter(sample => {
    let heard = 0;
    for (let i = 0; i < played.length; i += 1) {
      heard += Math.max(0, Math.min(played.end(i), sample.end_seconds)
        - Math.max(played.start(i), sample.start_seconds));
    }
    return heard >= sample.required_seconds;
  }).map(sample => sample.sample_id);
}
